import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { StatisticsSummaryItem } from '@/summaryReport/summaryData.types';
import { adjustColor } from '@/summaryReport/summaryReport.utilities';

interface StatisticsSummaryBoxPlotProps {
  items: StatisticsSummaryItem[];
  title?: string;
  xAxisTitle?: string;
  yAxisTitle?: string;
}

export const StatisticsSummaryBoxPlot: React.FunctionComponent<StatisticsSummaryBoxPlotProps> = ({
  items,
  title,
  xAxisTitle,
  yAxisTitle,
}) => {
  const isMultiple = items.length > 1;
  const getBoxPlotData = (item: StatisticsSummaryItem) => {
    if (item?.data) {
      return [
        item.data.stats.quartile0,
        item.data.stats.quartile1,
        item.data.stats.quartile2,
        item.data.stats.quartile3,
        item.data.stats.quartile4,
      ];
    }
    return [0, 0, 0, 0, 0];
  };

  const series = items.map((item) => ({
    name: item.name,
    data: [getBoxPlotData(item)],
    type: 'boxplot' as const,
    color: item.color,
    fillColor: adjustColor(item.color),
  }));

  const options: Highcharts.Options = {
    chart: {
      type: 'boxplot',
      inverted: true,
      height: isMultiple ? '80%' : '200px',
      animation: false,
    },
    legend: {
      enabled: isMultiple,
      verticalAlign: 'top',
    },
    credits: {
      enabled: false,
    },
    title: {
      text: title,
      align: 'left',
      style: {
        fontSize: 'small',
        fontWeight: 'normal',
      },
    },
    xAxis: {
      visible: false,
      title: {
        text: xAxisTitle,
      },
    },
    yAxis: {
      title: {
        text: yAxisTitle,
      },
    },
    plotOptions: {
      boxplot: {
        animation: false,
      },
    },
    series,
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
